var axios = require('axios');

// Create API client
var apiClient = axios.create({
  baseURL: '/'
});

// Add request interceptor
apiClient.interceptors.request.use(function(config) {
  console.log('API Request:', config.url, config.params);
  return config;
}, function(error) {
  return Promise.reject(error);
});

// Add response interceptor
apiClient.interceptors.response.use(function(response) {
  console.log('API Response:', response.config.url, response.status);
  
  // Check and standardize data format
  if (response.data && typeof response.data === 'object') {
    // If API returns inconsistent data structure, standardize it here
    console.log('Original API data structure:', response.data);
  }
  
  return response;
}, function(error) {
  console.error('API Error:', error.config ? error.config.url : 'Unknown URL', error.message);
  return Promise.reject(error);
});

module.exports = {
  // Get latest draw results
  getLastResult: function(gameId) {
    if (!gameId) {
      console.error('getLastResult: gameId is required');
      return Promise.reject(new Error('gameId is required'));
    }
    
    return apiClient.get('api/history/getLastResult', {
      params: {
        game: gameId,
        type: 'json'
      }
    });
  },
  // Get historical draw results
  getHistoryResults: function(gameId, pageNum, searchIssue, searchDate, limit) {
    if (!gameId) {
      console.error('getHistoryResults: gameId is required');
      return Promise.reject(new Error('gameId is required'));
    }
    
    var params = {
      game: gameId,
      pageNum: pageNum || 1,
      limit: limit || 10
    };
    
    // Only add search parameters if they have values
    if (searchIssue) {
      params.searchIssue = searchIssue;
    }
    
    if (searchDate) {
      // Single date search
      params.searchDate = searchDate;
    }
    
    return apiClient.get('api/history/getPageIndexData', { params: params });
  }
}; 


// WEBPACK FOOTER //
// ./src/services/api.js